jQuery(document).ready(function($) {

    //fieldsAutofill( $('#contact-form') );

    grecaptcha.ready(function() {
        grecaptcha.execute( formContactData.reCaptcha.siteKey, {action: formContactData.reCaptcha.action}).then(function(token) {
            $('#contact-form').submit(function(e){
                e.preventDefault();
                $.ajax({
                    url: formContactData.ajaxUrl,
                    type: "POST",
                    cache: false,
                    data: {
                        action : 'send_email',
                        subject : $('#subject').val(),
                        name : $('#name').val(),
                        first_name : $('#first-name').val(),
                        tel : $('#tel').val(),
                        email : $('#email').val(),
                        message : $('#message').val(),
                        security : $('#security').val(),
                        token: token,
                    },
                    success: function(res) {
                        console.log(res);
                        if (res.success) {
                            $('#contact-form .btn[type=submit]')
                                .addClass('success')
                                .html(formContactData.sentMessageText)
                                ;
                        }
                        else {
                            $('#contact-form .btn[type=submit]')
                                .addClass('error')
                                .html(formContactData.errorMessageText)
                                ;
                        }
                        
                    }
                });
            });
        });
    });
});